<template>
    <div class="completed-history-view-container">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div class="event-info-wrapper">
            <EventManageHeader
                :eventId="parseInt(eventId)"
                :userId="parseInt(userId)"
                :eventDate="eventInfo.start_date"
                mode="artistEvent"
            />
        </div>
        <div class="divider"></div>
        <div class="payout-info-wrapper">
            <p class="subtitle">Payout</p>
            <PayoutSummary :eventId="parseInt(eventId)" />
        </div>
        <div class="divider"></div>
        <div class="feedback-info-wrapper">
            <p class="subtitle">Feedback</p>
            <div v-if="artistReview.length">
                <div class="venue-reviews">
                    <div v-for="(review, indx) in artistReview" :key="indx">
                        <EventFeedbackCards :review="review" mode="Venue" />
                    </div>
                </div>
            </div>
            <div v-else class="venue-missed">No reviews have been submitted</div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import { notification } from '@/helpers/notification'
    import EventManageHeader from '@/components/booking-manager/booking-part/EventManageHeader.vue'
    import PayoutSummary from './PayoutSummary.vue'
    import EventFeedbackCards from '@/components/booking-manager/booking-part/completed-event/EventFeedbackCards.vue'

    const URLS = {
        xhr: {
            fetch: {
                eventInfo: '/api/event/publish-event',
                artistReview: '/api/get/artist'
            }
        }
    }

    export default {
        name: 'CompletedHistoryView',
        props: {
            'event-id': {
                required: true,
                type: String
            },
            userId: {
                required: true,
                type: String
            }
        },
        components: {
            EventManageHeader,
            PayoutSummary,
            EventFeedbackCards
        },
        data: () => ({
            load: false,
            eventInfo: {},
            artistReview: {}
        }),
        computed: {
            URLS: () => URLS
        },
        async created() {
            this.eventInfo = await this.fetchEventInfo()
            this.artistReview = await this.fetchArtistReview()
        },
        methods: {
            async fetchEventInfo() {
                try {
                    this.load = true
                    const resp = await axios.get(
                        `${this.URLS.xhr.fetch.eventInfo}/${this.eventId}?preview=true`
                    )

                    return resp.data.event
                } catch (e) {
                    notification('error', e)
                } finally {
                    this.load = false
                }
            },
            async fetchArtistReview() {
                try {
                    this.load = true
                    const resp = await axios.get(
                        `${this.URLS.xhr.fetch.artistReview}/${this.eventId}`
                    )

                    return resp.data.data
                } catch (e) {
                    notification('error', e)
                } finally {
                    this.load = false
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .completed-history-view-container {
        max-width: 1150px;
        padding: 0px 50px;
        margin-right: auto;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }
        .subtitle {
            margin-bottom: 32px;
            color: #acacac;
            font-family: Instrument Sans;
            font-size: 44px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -1.76px;
        }
        .divider {
            width: 100%;
            height: 1px;
            background: #646464;
            margin-top: 29px;
            margin-bottom: 64px;
        }
        .booked-artists-wrapper,
        .payout-info-wrapper {
            margin-bottom: 35px;
        }
        .feedback-info-wrapper {
            padding-bottom: 152px;

            .venue-reviews {
                display: flex;
                flex-direction: column;
                gap: 25px;
            }
        }
        .venue-missed {
            padding-top: 64px;
            margin-top: 29px;
            color: #acacac;
            font-family: 'Instrument Sans';
            font-size: 26px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -1.76px;
        }
    }
    @media (max-width: 600px) {
        .completed-history-view-container {
            padding: 0px;
        }
    }
</style>
